import React from 'react';
import { MapPin, Sun, Heart, Store } from 'lucide-react';
import { useReveal, JoinBlock, InstagramSection, PageHeader } from '../components/shared';
import { JOURNEY, PILLARS } from '../mock';

const VALUES = [
  [MapPin, 'Locally Grown', 'Every stem is grown right here in Torquay, a short walk from the beach.'],
  [Sun, 'Seasonal Beauty', 'We grow with the Surf Coast seasons — what\'s out is what\'s truly in bloom.'],
  [Heart, 'Grown with Love', 'Two people, one paddock, and a whole lotta care in every bunch.'],
  [Store, 'Support Local', 'A small family farm, backing our community and other small makers.'],
];

export default function About({ go }) {
  useReveal([]);
  return (
    <div className="page active" data-testid="about-page">
      <PageHeader eyebrow="Torquay Flower Farm" title="About" sub="Laura & Matt, and a paddock behind the dunes" cta="Join Our Community" ctaPink onCta={() => go('tubers', { scrollToJoin: true })} />

      <div className="split about-hero">
        <div className="split-photo bg-photo" style={{ backgroundImage: `url(/brand/about.webp)` }} />
        <div className="split-copy">
          <span className="eyebrow rev">Meet Laura &amp; Matt</span>
          <h2 className="home-split-h rev">From backyard<em>to flower farm</em></h2>
          <p className="body-text rev">Hi, we&rsquo;re Laura and Matt. Everything begins on a windswept paddock behind the dunes at Torquay — the same stretch of coast where we surf before work, swim after it, and spend most weekends chasing sun. Loving this place enough to live by its rhythms is what got the farm started in the first place.</p>
          <p className="body-text rev">What started as five dahlia tubers in the backyard has grown into South Beach Blooms, our Torquay Flower Farm: seasonal flowers built for salt air and sandy soil, a farm gate opening for its very first season, and a growing collection of beautiful, ridiculously good dahlia varieties we can&rsquo;t wait to share.</p>
          <p className="rev" style={{ fontFamily: "'Alex Brush',cursive", fontSize: 30, color: 'var(--bayleaf)', marginTop: 6, lineHeight: 1 }}>Laura &amp; Matt x</p>
        </div>
      </div>

      <div className="about-dream" data-testid="about-dream">
        <span className="eyebrow rev">Our dream</span>
        <p className="about-dream-text rev">Our hope is that our community can simply push the pram or take a morning walk across the road to our farm gate and fill their day with a little colour and joy. Or if you&rsquo;re just passing through on your way down the coast, stop by the farm gate, grab some blooms and keep on driving.</p>
        <p className="about-dream-sign rev">Welcome to Torquay Flower Farm &mdash; we&rsquo;re so glad you&rsquo;re here.</p>
      </div>

      <div className="offer-grid about-values" data-testid="about-values">
        {VALUES.map(([Ic, t, d], i) => (
          <div className="offer-card rev" key={i}>
            <span className="offer-icon"><Ic size={28} strokeWidth={1.3} /></span>
            <div className="offer-title">{t}</div>
            <p className="offer-body">{d}</p>
          </div>
        ))}
      </div>

      <div className="journey-wrap">
        <span className="eyebrow rev" style={{ textAlign: 'center', display: 'block' }}>From Tuber to Bloom</span>
        <h2 className="serif-h rev" style={{ textAlign: 'center' }}>Our journey so far.</h2>
        <div className="journey-list">
          {JOURNEY.map((j, i) => (
            <div className="journey-item rev" key={i}>
              <div className="journey-date">{j.date}</div>
              <div className="journey-text">{j.text}</div>
            </div>
          ))}
        </div>
      </div>

      <div className="pillars-section">
        <span className="eyebrow rev">Our Approach</span>
        <h2 className="serif-h rev">How we grow.</h2>
        <div className="pillars-grid">
          {PILLARS.map((p, i) => (
            <div className="pillar" key={i}>
              <span className="pillar-n">{p.n}</span>
              <div className="pillar-t">{p.t}</div>
              <p className="pillar-d">{p.d}</p>
            </div>
          ))}
        </div>
      </div>

      <JoinBlock eyebrow="Inaugural Dahlia Sale · September 2027" headline="We sell to our community first." body="First access to tubers. Farm gate updates. Growing tips. Behind the scenes. All of it — to our community, before anyone else." />
      <InstagramSection />
    </div>
  );
}
